import { URI } from '@/config/config';

export default async ({ rootState }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const parksResult = await fetch(`${URI}park/list-parks`, opts);
  const jsonResult = await parksResult.json();
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
